import { Component, Input, OnInit } from '@angular/core';
import { NoteSection } from 'src/app/model/section/note-section';

@Component({
  selector: 'app-api-reference-note-section',
  templateUrl: './api-reference-note-section.component.html',
  styleUrls: ['./api-reference-note-section.component.scss']
})
export class ApiReferenceNoteSectionComponent implements OnInit {
  @Input() noteSections: NoteSection[] = [];

  constructor() {}

  ngOnInit(): void {}
}
